import { render } from "./ViewsSupport.vue?vue&type=template&id=10e1b859"
import script from "./ViewsSupport.vue?vue&type=script&lang=js"
export * from "./ViewsSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__